import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  ActivityIndicator,
} from "react-native";
//import FastImage from 'react-native-fast-image';
import { connect, useSelector } from "react-redux";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import { Network } from "../../../utils/network";
import BackgroundHeaderCard from "../childComponents/backgroundHeaderCard";
import ClubLiveCloseCard from "../childComponents/clubLiveCloseCard";
import ClubOwnerDetails from "../childComponents/clubOwnerDetails";
import SocialMarketCard from "../childComponents/socialMarketCard";
import {
  fetchClubMarkets,
  getClubListLive,
  getClubListClosed,
} from "../redux/clubs.action";
import { setLoaderVisibility } from "../../../utils/commonredux/commonRedux.action";
import { globalFontStyle, globalStyle } from "../../../assets";
import CommonModal from "../../../commonComponents/commonModal";
import JoinFirst from "../childComponents/joinFirst";
import Toast from "react-native-toast-message";
import NoMarket from "../../../commonComponents/NoMarkets";
import { useFocusEffect } from "@react-navigation/native";
import { trackMoengageEvent } from "../../../utils/commonMethods";
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";

const MobileJoinClub = ({
  navigation,
  route,
  fetchClubMarkets,
  markets,
  getClubListLive,
  getClubListClosed,
  liveMarkets,
  closedMarkets,
  liveLoading,
  closedLoading,
  setLoaderVisibility,
}) => {
  const [headerOptions, setHeaderOptions] = useState("markets");
  const { club_id = "", tab = "" } = route.params;
  const [isMember, setMember] = useState(true);
  const [isOwner, setOwner] = useState(false);
  const [club, setClub] = useState();
  const isAppLogin = useSelector(({ utilReducer }) => utilReducer.isAppLogin);
  const [showFAQ, setShowFAQ] = React.useState(false);

  const onHeaderOptionsClick = (value) => {
    setHeaderOptions(value);
    if (value === "Live") {
      getClubLive(club_id);
    } else if (value === "Closed") {
      getClubClosed(club_id);
    } else if (value === "markets") {
      fetchClubMarkets(club_id);
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      return () => {
        navigation.setParams({ tab: "" });
      };
    }, [])
  );

  const getClubLive = async (club_id) => {
    await getClubListLive(club_id);
  };

  const getClubClosed = async (club_id) => {
    await getClubListClosed(club_id);
  };

  useEffect(() => {
    if (tab === "Live") {
      setHeaderOptions("Live");
      getClubLive(club_id);
      getClubDetails(club_id, true);
    } else {
      getClubDetails(club_id);
    }
  }, [tab]);

  const getClubDetails = async (club_id, isLive) => {
    const res = await Network.fetchClubDetails(club_id);
    if (res?.data?.is_member) {
      setMember(true);
    } else {
      setMember(false);
    }
    setOwner(res?.data?.is_owner ? true : false);
    const clubs = res?.data?.clubs;
    if (clubs && clubs.length > 0) {
      setClub(clubs[0]);
    }
    if (!isLive) {
      await fetchClubMarkets(club_id);
    }

    setLoaderVisibility(false);
  };

  const onMarketClick = (market, marketId) => {
    if (!isMember) {
      setShowFAQ(true);
    } else {
      trackMoengageEvent("Club Market click", {
        market_id: marketId,
        club_id: club_id,
        title: market?.title,
        volume: market?.volume,
        options: market?.options_count,
      });
      navigation.push("ClubMarketDetail", {
        clubId: club_id,
        eventId: marketId,
      });
    }
  };

  const joinClub = async () => {
    if (isAppLogin) {
      trackMoengageEvent("Join Club Link", {
        club: club?.id,
      });
      setLoaderVisibility(true);
      const res = await Network.joinClub(club?.id);
      setLoaderVisibility(false);
      if (res?.data?.success) {
        setMember(true);
        Toast.show({
          type: "info",
          text1: '"Club Joined Successfully"',
          visibilityTime: 2000,
          position: "bottom",
        });
      } else {
        setMember(false);
      }
    } else {
      navigation.navigate("Login", { isFromClub: true });
    }
  };

  const backButtonHandle = () => {
    navigation.pop();
  };

  const onBottomSheetClose = () => {
    setShowFAQ(false);
  };

  const handleEmpty = () => {
    return <NoMarket source="home" />;
  };

  return (
    <View style={{ flex: 1, backgroundColor: Colors.bgWhite }}>
      <BackgroundHeaderCard
        pageTitle={club?.title}
        backButtonHandle={backButtonHandle}
      />
      <View
        style={{
          flex: 1,
          paddingHorizontal: 16,
        }}
      >
        <ClubOwnerDetails club={club} isMember={isMember} />
        {!isMember && <Text>Available markets</Text>}
        {isOwner && <Text>Your active markets</Text>}
        {isAppLogin && isMember && !isOwner && (
          <View
            style={{
              flexDirection: "row",
              marginTop: 16,
              justifyContent: "space-around",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <TouchableOpacity
              style={
                headerOptions === "markets"
                  ? styles.selectedBorderColor
                  : styles.unselectedBorder
              }
              activeOpacity={0.8}
              onPress={() => {
                onHeaderOptionsClick("markets");
              }}
            >
              <Text
                style={[
                  headerOptions === "markets"
                    ? styles.selectedHeading
                    : styles.unselectedHeading,
                ]}
              >
                Markets
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.8}
              style={
                headerOptions === "Live"
                  ? styles.selectedBorderColor
                  : styles.unselectedBorder
              }
              onPress={() => {
                onHeaderOptionsClick("Live");
              }}
            >
              <Text
                style={[
                  headerOptions === "Live"
                    ? styles.selectedHeading
                    : styles.unselectedHeading,
                ]}
              >
                Live
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                onHeaderOptionsClick("Closed");
              }}
              activeOpacity={0.8}
              style={
                headerOptions === "Closed"
                  ? styles.selectedBorderColor
                  : styles.unselectedBorder
              }
            >
              <Text
                style={[
                  headerOptions === "Closed"
                    ? styles.selectedHeading
                    : styles.unselectedHeading,
                ]}
              >
                Closed
              </Text>
            </TouchableOpacity>
          </View>
        )}
        {headerOptions === "markets" ? (
          <FlatList
            contentContainerStyle={{ paddingBottom: 350 }}
            //ListHeaderComponent={headerComponent}
            scrollEnabled
            ListEmptyComponent={handleEmpty}
            data={markets?.events}
            renderItem={(itemList, index) => {
              return (
                <TouchableOpacity
                  activeOpacity={0.8}
                  onPress={() => onMarketClick(itemList.item, itemList.item.id)}
                >
                  <SocialMarketCard market={itemList?.item} />
                </TouchableOpacity>
              );
            }}
            //onRefresh={PullToRefresh}
            //refreshing={loading}
            keyExtractor={(item, index) => index}
            showsVerticalScrollIndicator={false}
            initialNumToRender={50}
          />
        ) : liveLoading || closedLoading ? (
          <View
            style={{
              height: 40,
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <ActivityIndicator size="large" color={globalConfigurableData.loaderColor} />
          </View>
        ) : (
          <FlatList
            contentContainerStyle={{ paddingBottom: 350 }}
            //ListHeaderComponent={headerComponent}
            scrollEnabled
            ListEmptyComponent={handleEmpty}
            data={
              headerOptions === "Live"
                ? liveMarkets?.events
                : closedMarkets?.events
            }
            renderItem={(itemList, index) => {
              return (
                <TouchableOpacity activeOpacity={0.8} onPress={() => {}}>
                  <ClubLiveCloseCard
                    clubDetails={itemList.item}
                    isLive={headerOptions === "Live" ? true : false}
                  />
                </TouchableOpacity>
              );
            }}
            //onRefresh={PullToRefresh}

            keyExtractor={(item, index) => index}
            showsVerticalScrollIndicator={false}
            initialNumToRender={50}
          />
        )}
      </View>
      {isOwner && isAppLogin && (
        <View style={styles.bottomAbsBtnBar}>
          <CustomButton
            btnText={"+ Create an event"}
            btnType="normalBlue"
            onBtnClick={() => {
              navigation.push("ClubCreate", { clubId: club_id });
            }}
          />
        </View>
      )}

      {!isMember && (
        <View style={styles.bottomAbsBtnBar}>
          <Text style={{ marginBottom: 15, textAlign: "center" }}>
            {isAppLogin
              ? "You need to join the club to access the page"
              : "You need to register first in order to join the club"}
          </Text>
          <CustomButton
            btnText={isAppLogin ? "Join Club" : "Register to Join"}
            btnType="normalBlue"
            onBtnClick={joinClub}
          />
        </View>
      )}
      <CommonModal
        onModalCallBack={onBottomSheetClose}
        customModalStyle={[globalStyle.modalView]}
        showModal={showFAQ}
      >
        <JoinFirst
          closeBottomSheet={()=>{
            setTimeout(() => {
              onBottomSheetClose();
            }, globalConst?.buttonTimer);
          }}
          isLoggedIn={isAppLogin}
        />
      </CommonModal>
    </View>
  );
};

const mapStateToProps = ({ socialClubReducer }) => ({
  markets: socialClubReducer?.markets,
  liveMarkets: socialClubReducer?.clubLive,
  closedMarkets: socialClubReducer?.clubClosed,
  liveLoading: socialClubReducer.liveLoading,
  closedLoading: socialClubReducer.closedLoading,
});
const mapDispatchToProps = {
  setLoaderVisibility,
  fetchClubMarkets,
  getClubListLive,
  getClubListClosed,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileJoinClub);

const styles = StyleSheet.create({
  bottomAbsBtnBar: {
    position: "absolute",
    paddingHorizontal: 16,
    paddingVertical: 13,
    bottom: 0,
    width: Width.width,

    borderTopColor: "rgba(0, 0, 0, 0.5)",
    borderTopWidth: 0.191541,
    backgroundColor: Colors.bgWhite,
    justifyContent: "space-between",
    flex: 1,
  },
  selectedBorderColor: {
    borderBottomColor: Colors.black,
    borderBottomWidth: 1,
    flex: 1,
    alignItems: "center",
    paddingHorizontal: 5,
    paddingVertical: 5,
  },
  unselectedBorder: {
    flex: 1,
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#DFDFDF",
    paddingHorizontal: 5,
    paddingVertical: 5,
  },
  selectedHeading: {
    ...globalFontStyle.appFontSubHeading,
    color: Colors.black,
  },
  unselectedHeading: {
    ...globalFontStyle.appFontBody,
    color: Colors.black3,
  },
});
